


// import React, { useEffect, useState } from "react";
// import { Captcha } from "./Captcha";

// const states = [
//   { id: 1, name: "Andhra Pradesh" },
//   { id: 2, name: "Arunachal Pradesh" },
//   { id: 3, name: "Assam" },
//   { id: 4, name: "Bihar" },
//   { id: 5, name: "Chhattisgarh" },
//   { id: 6, name: "Goa" },
//   { id: 7, name: "Gujarat" },
//   { id: 8, name: "Haryana" },
//   { id: 9, name: "Himachal Pradesh" },
//   { id: 10, name: "Jharkhand" },
//   { id: 11, name: "Karnataka" },
//   { id: 12, name: "Kerala" },
//   { id: 13, name: "Madhya Pradesh" },
//   { id: 14, name: "Maharashtra" },
//   { id: 15, name: "Manipur" },
//   { id: 16, name: "Meghalaya" },
//   { id: 17, name: "Mizoram" },
//   { id: 18, name: "Nagaland" },
//   { id: 19, name: "Odisha" },
//   { id: 20, name: "Punjab" },
//   { id: 21, name: "Rajasthan" },
//   { id: 22, name: "Sikkim" },
//   { id: 23, name: "Tamil Nadu" },
//   { id: 24, name: "Telangana" },
//   { id: 25, name: "Tripura" },
//   { id: 26, name: "Uttar Pradesh" },
//   { id: 27, name: "Uttarakhand" },
//   { id: 28, name: "West Bengal" },
//   { id: 29, name: "Others" },
// ];

// const Slide = () => {
//   const [isDemoOptionOpen, setDemoOptionOpen] = useState(false);

//   const handleQuickOptionClick = () => {
//     setDemoOptionOpen(!isDemoOptionOpen);
//   };

//   useEffect(() => {
//     setDemoOptionOpen(true);
//   }, []);

//   const [status, setStatus] = useState("Submit");
//   const [captchaOk, setCaptchaOk] = useState(false);
//   const [errors, setErrors] = useState({});

//   const [info, setInfo] = useState({
//     name: "",
//     mobilenumber: "",
//     email: "",
//     selectedOption: "",
//     subOption: "",
//     state: "",
//   });

//   const handleChange = (event) => {
//     setInfo({
//       ...info,
//       [event.target.name]: event.target.value,
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!captchaOk) {
//       return setErrors((p) => ({ ...p, captcha: "Please complete the CAPTCHA verification." }));
//     }

//     setStatus("Sending...");

//     try {
//       let response = await fetch(`/api/inquiry`, {
//         method: "POST",
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "application/json;charset=utf-8",
//         },
//         body: JSON.stringify(info),
//       });

//       let result = await response.json();
//       alert(result.status);
//     } catch (error) {
//       console.error("Submit error:", error);
//       alert("Something went wrong. Please try again.");
//     } finally {
//       setStatus("Submit");
//       setInfo({
//         name: "",
//         mobilenumber: "",
//         email: "",
//         selectedOption: "",
//         subOption: "",
//         state: "",
//       });
//       setCaptchaOk(false);
//     }
//   };

//   const getOptions = () => {
//     switch (info.selectedOption) {
//       case "Civil/Architecture CAD":
//         return [
//           "Autocad", "Revit Architecture", "3D MAX", "Sketchup",
//           "Lumion", "Staad Pro", "Etabs", "Revit structure", "Civil 3d",
//         ];
//       case "Mechanical CAD":
//         return ["Autocad", "SolidWorks", "Catia", "Ansys", "Mep", "Fusion 360", "Cnc", "NX CAD"];
//       case "Electrical CAD":
//         return ["Autocad", "Matlab", "Plc"];
//       case "Project Management CAD":
//         return ["Ms Project", "Primavera"];
//       case "IT Courses":
//         return [
//           "Full Stack Development", "Cyber Security", "C Programming", "Accounting",
//           "Graphic Design", "Data Visualisation", "Software Testing", "Web Development",
//           "Database Management", "UI & UX", "PhotoShop", "Corel Draw", "Canva",
//           "CSS", "Figma", "HTML 5", "C++ Programming", "C# Programming",
//         ];
//       default:
//         return [];
//     }
//   };

//   return (
//     <>
//       <div className={`demo-option-container ${isDemoOptionOpen ? "open" : ""}`}>
//         <div className="aeroland__toolbar">
//           <div className="inner" style={{ background: "orange", textAlign: "right" }}>
//             <button
//               className="quick-option hint--bounce hint--left hint--black primary-color-hover-important"
//               style={{
//                 color: "White",
//                 transform: `rotate(180deg) ${isDemoOptionOpen ? "rotate(90deg)" : "rotate(90deg)"}`,
//                 fontSize: "17px",
//                 border: "none",
//                 background: "transparent",
//                 fontWeight: "bold",
//                 outline: "none",
//                 marginLeft: "-38px",
//                 lineHeight: "8.15",
//                 color: "black",
//                 textAlign: "center",
//               }}
//               onClick={handleQuickOptionClick}
//             >
//               GetInTouch
//             </button>
//           </div>
//         </div>

//         <div className="demo-option-wrapper">
//           <button
//             className="quick-option hint--bounce hint--left hint--black primary-color-hover-important"
//             onClick={handleQuickOptionClick}
//             style={{ backgroundColor: "white" }}
//           >
//             <img
//               src="img/closeicon.png"
//               style={{ width: "40px", marginLeft: "-10px", marginTop: "10px", backgroundColor: "white" }}
//               alt="Close"
//             />
//           </button>

//           <div className="business-solution-form-wrap mr-auto ml-auto">
//             <div className="contact-title text-center section-space--mb_40">
//               <b><h3 className="mb-10">Contact Us</h3></b>
//             </div>

//             <form id="applyOnlyEnqury" onSubmit={handleSubmit}>
//               <input type="hidden" name="valid" value="false" />
//               <div className="contact-form__two">
//                 <br />

//                 <div className="contact-inner" style={{ width: "260px" }}>
//                   <input
//                     name="name"
//                     type="text"
//                     placeholder="Name *"
//                     required
//                     id="name"
//                     pattern="[a-zA-Z\s]+"
//                     title="Please enter only alphabets"
//                     value={info.name}
//                     onChange={handleChange}
//                   />
//                 </div>

//                 <div className="contact-inner" style={{ width: "260px" }}>
//                   <input
//                     name="email"
//                     type="text"
//                     placeholder="Email id *"
//                     required
//                     id="email"
//                     pattern="[^\s@]+@[^\s@]+\.[^\s@]+"
//                     title="Please enter a valid email address"
//                     value={info.email}
//                     onChange={handleChange}
//                   />
//                 </div>

//                 <div className="contact-inner" style={{ width: "260px" }}>
//                   <input
//                     name="mobilenumber"
//                     type="text"
//                     placeholder="Contact No *"
//                     required
//                     id="mobilenumber"
//                     pattern="\d{10}"
//                     title="Please enter a 10-digit phone number"
//                     value={info.mobilenumber}
//                     onChange={handleChange}
//                   />
//                 </div>

//                 {/* ── State dropdown ── */}
//                 <div className="contact-inner" style={{ width: "260px" }}>
//                   <select
//                     className="p-3 border-0"
//                     value={info.state}
//                     name="state"
//                     required
//                     onChange={handleChange}
//                   >
//                     <option value="">Select State</option>
//                     {states.map((s) => (
//                       <option key={s.id} value={s.name}>
//                         {s.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 <div className="contact-inner" style={{ width: "260px" }}>
//                   <select
//                     className="p-3 border-0"
//                     value={info.selectedOption || ""}
//                     name="selectedOption"
//                     required
//                     onChange={handleChange}
//                   >
//                     <option value="">Select Category</option>
//                     <option value="Civil/Architecture CAD">Civil/Architecture</option>
//                     <option value="Mechanical CAD">Mechanical</option>
//                     <option value="Electrical CAD">Electrical</option>
//                     <option value="Project Management CAD">Project Management</option>
//                     <option value="IT Courses">IT Courses</option>
//                   </select>
//                 </div>

//                 <div className="contact-inner" style={{ width: "260px" }}>
//                   {info.selectedOption && (
//                     <select
//                       className="p-3 border-0"
//                       required
//                       name="subOption"
//                       value={info.subOption}
//                       onChange={handleChange}
//                     >
//                       <option value="">Select {info.selectedOption}</option>
//                       {getOptions().map((subOption) => (
//                         <option key={subOption} value={subOption}>
//                           {subOption}
//                         </option>
//                       ))}
//                     </select>
//                   )}
//                 </div>

//                 <Captcha onVerified={(ok) => { setCaptchaOk(ok); setErrors((p) => ({ ...p, captcha: "" })); }} />
//                 {errors.captcha && <span className="err-msg text-danger">{errors.captcha}</span>}

//                 <div className="comment-submit-btn text-center" style={{ color: "#ffc107" }}>
//                   <button
//                     className="ht-btn ht-btn-md"
//                     type="submit"
//                     name="submitEnqury"
//                     id="submitEnqury"
//                     style={{ backgroundColor: "#ffc107" }}
//                     disabled={status === "Sending..."}
//                   >
//                     {status}
//                   </button>
//                 </div>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Slide;


















import React, { useEffect, useState } from "react";
import { Captcha } from "./Captcha";

const states = [
  { id: 1, name: "Andhra Pradesh" },
  { id: 2, name: "Arunachal Pradesh" },
  { id: 3, name: "Assam" },
  { id: 4, name: "Bihar" },
  { id: 5, name: "Chhattisgarh" },
  { id: 6, name: "Goa" },
  { id: 7, name: "Gujarat" },
  { id: 8, name: "Haryana" },
  { id: 9, name: "Himachal Pradesh" },
  { id: 10, name: "Jharkhand" },
  { id: 11, name: "Karnataka" },
  { id: 12, name: "Kerala" },
  { id: 13, name: "Madhya Pradesh" },
  { id: 14, name: "Maharashtra" },
  { id: 15, name: "Manipur" },
  { id: 16, name: "Meghalaya" },
  { id: 17, name: "Mizoram" },
  { id: 18, name: "Nagaland" },
  { id: 19, name: "Odisha" },
  { id: 20, name: "Punjab" },
  { id: 21, name: "Rajasthan" },
  { id: 22, name: "Sikkim" },
  { id: 23, name: "Tamil Nadu" },
  { id: 24, name: "Telangana" },
  { id: 25, name: "Tripura" },
  { id: 26, name: "Uttar Pradesh" },
  { id: 27, name: "Uttarakhand" },
  { id: 28, name: "West Bengal" },
  { id: 29, name: "Others" },
];

const Slide = () => {
  const [isDemoOptionOpen, setDemoOptionOpen] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [status, setStatus] = useState("Submit");
  const [captchaOk, setCaptchaOk] = useState(false);
  const [errors, setErrors] = useState({});

  const [info, setInfo] = useState({
    name: "",
    mobilenumber: "",
    email: "",
    selectedOption: "",
    subOption: "",
    state: "",
  });

  const handleQuickOptionClick = () => {
    setDemoOptionOpen(!isDemoOptionOpen);
  };

  useEffect(() => {
    setDemoOptionOpen(true);
  }, []);

  const handleChange = (event) => {
    setInfo({
      ...info,
      [event.target.name]: event.target.value,
    });
  };

  const resetForm = () => {
    setInfo({
      name: "",
      mobilenumber: "",
      email: "",
      selectedOption: "",
      subOption: "",
      state: "",
    });
    setCaptchaOk(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaOk) {
      return setErrors((p) => ({ ...p, captcha: "Please complete the CAPTCHA verification." }));
    }

    setStatus("Sending...");

    try {
      let response = await fetch(`/api/inquiry`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify(info),
      });

      if (!response.ok) {
        throw new Error("Server error");
      }

      let result = await response.json();
      console.log(result);

      resetForm();
      setShowSuccess(true);
    } catch (error) {
      console.error("Submit error:", error);
      setShowError(true);
    } finally {
      setStatus("Submit");
    }
  };

  const getOptions = () => {
    switch (info.selectedOption) {
      case "Civil/Architecture CAD":
        return [
          "Autocad", "Revit Architecture", "3D MAX", "Sketchup",
          "Lumion", "Staad Pro", "Etabs", "Revit structure", "Civil 3d",
        ];
      case "Mechanical CAD":
        return ["Autocad", "SolidWorks", "Catia", "Ansys", "Mep", "Fusion 360", "Cnc", "NX CAD"];
      case "Electrical CAD":
        return ["Autocad", "Matlab", "Plc"];
      case "Project Management CAD":
        return ["Ms Project", "Primavera"];
      case "IT Courses":
        return [
          "Full Stack Development", "Cyber Security", "C Programming", "Accounting",
          "Graphic Design", "Data Visualisation", "Software Testing", "Web Development",
          "Database Management", "UI & UX", "PhotoShop", "Corel Draw", "Canva",
          "CSS", "Figma", "HTML 5", "C++ Programming", "C# Programming",
        ];
      default:
        return [];
    }
  };

  return (
    <>
      {/* ── Success Modal ── */}
      {showSuccess && (
        <div
          onClick={() => setShowSuccess(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.55)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 99999,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#fff",
              borderRadius: "14px",
              padding: "2.5rem 2rem",
              maxWidth: "360px",
              width: "90%",
              textAlign: "center",
              boxShadow: "0 12px 40px rgba(0,0,0,0.2)",
            }}
          >
            <div
              style={{
                width: 64,
                height: 64,
                borderRadius: "50%",
                background: "#EAF3DE",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 1.25rem",
              }}
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#3B6D11"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </div>
            <h3
              style={{
                margin: "0 0 0.5rem",
                fontSize: 20,
                fontWeight: 600,
                color: "#1a1a1a",
              }}
            >
              Submitted Successfully!
            </h3>
            <p
              style={{
                margin: "0 0 1.75rem",
                fontSize: 14,
                color: "#666",
                lineHeight: 1.7,
              }}
            >
              Thank you for reaching out! Our team will get back to you shortly.
            </p>
            <button
              onClick={() => setShowSuccess(false)}
              style={{
                padding: "0.55rem 2rem",
                borderRadius: 8,
                border: "none",
                background: "#ffc107",
                color: "#000",
                fontWeight: 600,
                fontSize: 15,
                cursor: "pointer",
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* ── Error Modal ── */}
      {showError && (
        <div
          onClick={() => setShowError(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.55)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 99999,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#fff",
              borderRadius: "14px",
              padding: "2.5rem 2rem",
              maxWidth: "360px",
              width: "90%",
              textAlign: "center",
              boxShadow: "0 12px 40px rgba(0,0,0,0.2)",
            }}
          >
            <div
              style={{
                width: 64,
                height: 64,
                borderRadius: "50%",
                background: "#FCEBEB",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 1.25rem",
              }}
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#A32D2D"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </div>
            <h3
              style={{
                margin: "0 0 0.5rem",
                fontSize: 20,
                fontWeight: 600,
                color: "#1a1a1a",
              }}
            >
              Something went wrong!
            </h3>
            <p
              style={{
                margin: "0 0 1.75rem",
                fontSize: 14,
                color: "#666",
                lineHeight: 1.7,
              }}
            >
              Please try again or contact us directly.
            </p>
            <button
              onClick={() => setShowError(false)}
              style={{
                padding: "0.55rem 2rem",
                borderRadius: 8,
                border: "none",
                background: "#ffc107",
                color: "#000",
                fontWeight: 600,
                fontSize: 15,
                cursor: "pointer",
              }}
            >
              Try Again
            </button>
          </div>
        </div>
      )}

      {/* ── Slide Panel ── */}
      <div className={`demo-option-container ${isDemoOptionOpen ? "open" : ""}`}>
        <div className="aeroland__toolbar">
          <div className="inner" style={{ background: "orange", textAlign: "right" }}>
            <button
              className="quick-option hint--bounce hint--left hint--black primary-color-hover-important"
              style={{
                transform: `rotate(180deg) ${isDemoOptionOpen ? "rotate(90deg)" : "rotate(90deg)"}`,
                fontSize: "17px",
                border: "none",
                background: "transparent",
                fontWeight: "bold",
                outline: "none",
                marginLeft: "-38px",
                lineHeight: "8.15",
                color: "black",
                textAlign: "center",
              }}
              onClick={handleQuickOptionClick}
            >
              GetInTouch
            </button>
          </div>
        </div>

        <div className="demo-option-wrapper">
          <button
            className="quick-option hint--bounce hint--left hint--black primary-color-hover-important"
            onClick={handleQuickOptionClick}
            style={{ backgroundColor: "white" }}
          >
            <img
              src="img/closeicon.png"
              style={{
                width: "40px",
                marginLeft: "-10px",
                marginTop: "10px",
                backgroundColor: "white",
              }}
              alt="Close"
            />
          </button>

          <div className="business-solution-form-wrap mr-auto ml-auto">
            <div className="contact-title text-center section-space--mb_40">
              <b>
                <h3 className="mb-10">Contact Us</h3>
              </b>
            </div>

            <form id="applyOnlyEnqury" onSubmit={handleSubmit}>
              <input type="hidden" name="valid" value="false" />
              <div className="contact-form__two">
                <br />

                <div className="contact-inner" style={{ width: "260px" }}>
                  <input
                    name="name"
                    type="text"
                    placeholder="Name *"
                    required
                    id="name"
                    pattern="[a-zA-Z\s]+"
                    title="Please enter only alphabets"
                    value={info.name}
                    onChange={handleChange}
                  />
                </div>

                <div className="contact-inner" style={{ width: "260px" }}>
                  <input
                    name="email"
                    type="text"
                    placeholder="Email id *"
                    required
                    id="email"
                    pattern="[^\s@]+@[^\s@]+\.[^\s@]+"
                    title="Please enter a valid email address"
                    value={info.email}
                    onChange={handleChange}
                  />
                </div>

                <div className="contact-inner" style={{ width: "260px" }}>
                  <input
                    name="mobilenumber"
                    type="text"
                    placeholder="Contact No *"
                    required
                    id="mobilenumber"
                    pattern="\d{10}"
                    title="Please enter a 10-digit phone number"
                    value={info.mobilenumber}
                    onChange={handleChange}
                  />
                </div>

                <div className="contact-inner" style={{ width: "260px" }}>
                  <select
                    className="p-3 border-0"
                    value={info.state}
                    name="state"
                    required
                    onChange={handleChange}
                  >
                    <option value="">Select State</option>
                    {states.map((s) => (
                      <option key={s.id} value={s.name}>
                        {s.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="contact-inner" style={{ width: "260px" }}>
                  <select
                    className="p-3 border-0"
                    value={info.selectedOption || ""}
                    name="selectedOption"
                    required
                    onChange={handleChange}
                  >
                    <option value="">Select Category</option>
                    <option value="Civil/Architecture CAD">Civil/Architecture</option>
                    <option value="Mechanical CAD">Mechanical</option>
                    <option value="Electrical CAD">Electrical</option>
                    <option value="Project Management CAD">Project Management</option>
                    <option value="IT Courses">IT Courses</option>
                  </select>
                </div>

                <div className="contact-inner" style={{ width: "260px" }}>
                  {info.selectedOption && (
                    <select
                      className="p-3 border-0"
                      required
                      name="subOption"
                      value={info.subOption}
                      onChange={handleChange}
                    >
                      <option value="">Select {info.selectedOption}</option>
                      {getOptions().map((subOption) => (
                        <option key={subOption} value={subOption}>
                          {subOption}
                        </option>
                      ))}
                    </select>
                  )}
                </div>

                <Captcha
                  onVerified={(ok) => {
                    setCaptchaOk(ok);
                    setErrors((p) => ({ ...p, captcha: "" }));
                  }}
                />
                {errors.captcha && (
                  <span className="err-msg text-danger">{errors.captcha}</span>
                )}

                <div
                  className="comment-submit-btn text-center"
                  style={{ color: "#ffc107" }}
                >
                  <button
                    className="ht-btn ht-btn-md"
                    type="submit"
                    name="submitEnqury"
                    id="submitEnqury"
                    style={{ backgroundColor: "#ffc107" }}
                    disabled={status === "Sending..."}
                  >
                    {status}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Slide;